// extracted by mini-css-extract-plugin
export var conversationListItem = "_xe-2";
export var fullBleedList = "_xe-3";
export var messageText = "_xe-1";
export var previewText = "_xe-0";